/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "Admin settingsManager/services/OverwritesService";
const serviceEndpoint = (queueId) => `${APIGateways.queueConfigEndpoint}/${queueId}/overwrites`;

export const updateOverwritesAsync = async (updateObject, queueId) => {
	try {
		let updateResponses = await axios.post(serviceEndpoint(queueId), updateObject, {
			headers: await getAuthHeader(),
		});
		return updateResponses.data;
	} catch (error) {
		v2.error(`Error updating overwrites for queue ${queueId}`, {
			additionalData: { error: errorToObject(error), data: { queueId, updateObject } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.UPDATE_OVERWRITES_API_ERROR,
		});
		throw error;
	}
};

export const getOverwritesAsync = async (queueId) => {
	try {
		let overwrites = await axios.get(serviceEndpoint(queueId), {
			headers: await getAuthHeader(),
		});
		return overwrites.data.results;
	} catch (error) {
		v2.error(`Error getting overwrites for queue ${queueId}`, {
			additionalData: { error: errorToObject(error), data: { queueId } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.GET_OVERWRITES_API_ERROR,
		});
		throw error;
	}
};
